function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { Suspense, useEffect } from "react";
import { useQueryLoader } from "react-relay/hooks";
import { useSdkContext } from "~/components/contexts";
import { FooterDisplay, query } from "~/components/footer/footer-display";
/**
 * You need to wrap with SdkContext before use this component
 */
export const Footer = ({
  loadingComponent,
  ...props
}) => {
  const {
    config
  } = useSdkContext();
  const [queryReference, loadQuery, disposeQuery] = useQueryLoader(query);
  useEffect(() => {
    loadQuery({
      footerNewsletterId: config.newsletter.globalImpact
    });
    return disposeQuery;
  }, [loadQuery, disposeQuery, config.newsletter.globalImpact]);
  return /*#__PURE__*/React.createElement(Suspense, {
    fallback: loadingComponent !== null && loadingComponent !== void 0 ? loadingComponent : "loading...",
    "data-qa": "footer"
  }, queryReference && /*#__PURE__*/React.createElement(FooterDisplay, _extends({}, props, {
    queryReference: queryReference
  })));
};
Footer.displayName = "Footer";